export default event => event.stopPropagation();